<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import * as def from '@/lib/definition'

export default {
  props: [
    'pageId'
  ],
  setup: () => ({
    newDoc: def.newDoc
  }),
  computed: {
    ...mapState([
      'pages',
      'editor'
    ]),
    page () {
      return this.pages[this.pageId] || { articles: {} }
    },
    routeId () {
      return this.$route.params.articleId || (this.$route.name === 'page-images' ? 'page-images' : false)
    },
    articles () {
      const articles = []
      Object.keys(this.page.articles).forEach(key => articles.push(this.page.articles[key]))
      articles.sort((a, b) => b.publication_date - a.publication_date)
      return articles
    }
  },
  watch: {
    pageId: {
      immediate: true,
      handler () {
        this.fetchArticles(this.pageId)
      }
    }
  },
  methods: {
    ...mapMutations([
      'setEditor'
    ]),
    ...mapActions([
      'fetchArticles'
    ])
  }
}
</script>

<template>
  <div class="page level-left is-mobile">
    <section class="article-list">
      <h1 class="is-size-3">{{ pageId }}/</h1>
      <ul>
        <li v-for="article in articles" :key="article.id">
          <router-link :to="{name: 'article', params: {articleId: article.id}}">
            <span class="link">{{ article.id }} {{ article.title }}</span>
          </router-link>
        </li>
        <li>
          <button
            @click="setEditor(newDoc[pageId])"
            class="button"
          >
            <i class="material-icons">add_circle</i>
            <span>記事を作成する</span>
          </button>
        </li>
      </ul>
      <hr>
      <div>
        <router-link :to="{ name: 'page-images' }">
          <span class="link">画像の管理</span>
        </router-link>
      </div>
    </section>
    <div
      class="route-transition"
      :class="{ 'pointer-cancel': !routeId }"
    >
      <router-view v-slot="{ Component }">
        <transition name="slide">
          <component
            v-if="routeId"
            :is="Component"
            :key="routeId"
          />
        </transition>
      </router-view>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "../styles/variables";
.page {
  align-items: flex-start;
  height: 100%;
  width: calc(100vw - #{variables.$width-page-list});
  border-left: 2px solid variables.$gray-light;
  background-color: variables.$gray-lighter;
  overflow: hidden;
  section {
    width: variables.$width-article-list;
  }
  .route-transition {
    width: calc(100vw - #{variables.$width-page-list} - #{variables.$width-article-list});
    z-index: 1;
  }
  .pointer-cancel {
    pointer-events: none;
  }
}
</style>
